import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  card: {
    display: 'flex',
    margin: '16px',
    width: '900px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    flexDirection: 'column',
    [theme.breakpoints.down('500')]: {
      width: '100%',
      margin: 0,
      maxHeight: 'none',
      height: 'inherit',
      borderRadius: 0,
      overflow: 'unset'
    },

    
  },

  title: {
    padding: '0 16px'
  },

  form: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    height: 350,
    maxHeight: 'calc(100vh - 400px)',
    overflowY: 'scroll',
    textAlign: 'left',
    [theme.breakpoints.down('500')]: {
      maxHeight: 'none',
      height: 'inherit',
    },
  },



  skeleton: {
    padding: '16px',
    '& .MuiSkeleton-rect': {
      borderRadius: '5px',
      marginBottom: '16px'
    },
    '& .line': {
      display: 'flex'
    },
    '& .line > *:not(:last-child)': {
      marginRight: '16px'
    }
  },

  tabSkeleton: {
    background: 'lightgray!important',
    marginRight: '16px',
    width: 'calc(20% - 14px) !important'
    
  }

}))